import { render, staticRenderFns } from "./SimilarityViewSelect.vue?vue&type=template&id=c8f677aa&scoped=true&"
import script from "./SimilarityViewSelect.vue?vue&type=script&lang=js&"
export * from "./SimilarityViewSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f677aa",
  null
  
)

export default component.exports